// This file was automatically generated from print.visitNote.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.visitNote');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.core');
goog.require('el8.template.print');
goog.require('el8.template.print.visitNote.oneCol');
goog.require('el8.template.print.visitNote.twoCol');
goog.require('el8.template.ptdata.model.note');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.visitNote.title(opt_data, output);
  el8.template.print.visitNote.body(soy.$$augmentData(opt_data.note, {showBilling: opt_data.showBilling, showMu: opt_data.showMu}), output);
  if (opt_data.note.signDate) {
    el8.template.print.signature({localFsPath: opt_data.localFsPath, signPhysicianName: opt_data.note.signUserName, signDate: opt_data.note.signDate}, output);
  }
  el8.template.print.visitNote.signLog(opt_data, output);
  if (! el8Globals.FEATURES.CoSignature) {
    var eList17578 = opt_data.note.edits;
    var eListLen17578 = eList17578.length;
    for (var eIndex17578 = 0; eIndex17578 < eListLen17578; eIndex17578++) {
      var eData17578 = eList17578[eIndex17578];
      output.append((eData17578.signDate) ? '<p>Amended and electronically signed by ' + soy.$$escapeHtml(eData17578.signUserName) + ' on ' + (soy.$$escapeHtml(eData17578.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(eData17578.signDate)) : '') + '</p>' : '<p>In-progress amendment created by ' + soy.$$escapeHtml(eData17578.createUserName) + ' on ' + (soy.$$escapeHtml(eData17578.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(eData17578.createDate)) : '') + '</p>');
    }
  }
  output.append('</div>');
  var imageList17596 = opt_data.note.fullSizeImages;
  var imageListLen17596 = imageList17596.length;
  for (var imageIndex17596 = 0; imageIndex17596 < imageListLen17596; imageIndex17596++) {
    var imageData17596 = imageList17596[imageIndex17596];
    output.append('<div class="pageWrap pageBreak"><div><img class="previewItem el8MaxWidth100" src="', soy.$$escapeHtml(imageData17596), '" /></div><br/>');
    el8.template.print.patientInfoFooter(opt_data, output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.signLog = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.note.signatures) {
    var signatureList17606 = opt_data.note.signatures;
    var signatureListLen17606 = signatureList17606.length;
    for (var signatureIndex17606 = 0; signatureIndex17606 < signatureListLen17606; signatureIndex17606++) {
      var signatureData17606 = signatureList17606[signatureIndex17606];
      output.append((signatureData17606.signatureRole == 'cosigner') ? '<p>Co-signed electronically by ' + soy.$$escapeHtml(signatureData17606.userName) + ' on ' + (soy.$$escapeHtml(signatureData17606.signedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(signatureData17606.signedAt)) : '') + ((signatureData17606.signatureComments) ? ': "' + soy.$$escapeHtml(signatureData17606.signatureComments) + '"' : '') + '</p>' : (signatureData17606.signatureRole == 'amender') ? '<p>Amended and signed by ' + soy.$$escapeHtml(signatureData17606.userName) + ' on ' + (soy.$$escapeHtml(signatureData17606.signedAt)? el8.service.tz.soyDateTime(soy.$$escapeHtml(signatureData17606.signedAt)) : '') + '</p>' : '');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.body = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.print.visitNote.sectionReason(opt_data, output);
  el8.template.print.visitNote.sectionPreOp(opt_data, output);
  if (opt_data.templateClass == 'oneCol') {
    el8.template.print.visitNote.oneCol.content(opt_data, output);
  } else if (opt_data.templateClass == 'twoCol') {
    el8.template.print.visitNote.twoCol.content(opt_data, output);
  }
  el8.template.print.visitNote.sectionFollowup(opt_data, output);
  if (opt_data.showBilling) {
    el8.template.print.visitNote.sectionBilling(soy.$$augmentData(opt_data.bill, {meaningfulUseInfo: opt_data.meaningfulUseInfo, showMu: opt_data.showMu}), output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.sectionReason = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.reasonBullets.length) {
    output.append('<h3 class="reasonTitle">Exam Reason (CC): ');
    el8.template.core.singleField({bullets: opt_data.reasonBullets}, output);
    output.append('</h3>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.sectionFollowup = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.followupBullets.length) {
    output.append('<h4>Follow-up</h4><p class="preserve">');
    el8.template.core.singleField({bullets: opt_data.followupBullets}, output);
    output.append('</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.sectionPreOp = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.dateprocedureBullets.length) {
    output.append('<p class="preserve">Date of Procedure: ');
    el8.template.core.singleField({bullets: opt_data.dateprocedureBullets}, output);
    output.append('</p>');
  }
  if (opt_data.consultantBullets.length) {
    output.append('<p class="preserve">Consultant: ');
    el8.template.core.singleField({bullets: opt_data.consultantBullets}, output);
    output.append('</p>');
  }
  if (opt_data.attendingBullets.length) {
    output.append('<p class="preserve">Attending Physician: ');
    el8.template.core.singleField({bullets: opt_data.attendingBullets}, output);
    output.append('</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.sectionBilling = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.cpts && opt_data.cpts.length > 0 || opt_data.notes || opt_data.refNumber || opt_data.billingDate || opt_data.meaningfulUseInfo && opt_data.showMu && opt_data.meaningfulUseInfo.transitionOfCare) {
    output.append((opt_data.showMu) ? '<h4>Billing & MIPS Information</h4>' : '<h4>Billing Information</h4>', '<table class="subSection">');
    if (opt_data.cpts && opt_data.cpts.length > 0 || opt_data.refNumber || opt_data.billingDate) {
      output.append('<tr><td class="subSectionTitle">Bill:</td><td class="subSectionText"><ul class="list">');
      var cptList17687 = opt_data.cpts;
      var cptListLen17687 = cptList17687.length;
      for (var cptIndex17687 = 0; cptIndex17687 < cptListLen17687; cptIndex17687++) {
        var cptData17687 = cptList17687[cptIndex17687];
        output.append('<li class="itemBullet preserve">');
        el8.template.ptdata.model.note.billCptSummary(soy.$$augmentData(cptData17687, {isShowDualCoding: opt_data.showDualCoding}), output);
        output.append('</li>');
      }
      output.append((opt_data.refNumber || opt_data.billingDate) ? '<li class="itemBullet preserve">' + ((opt_data.billingDate) ? 'Billed on ' + (soy.$$escapeHtml(opt_data.billingDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.billingDate)) : '') : 'Date unknown') + ' ' + ((opt_data.refNumber) ? '(#' + soy.$$escapeHtml(opt_data.refNumber) + ').' : '') + '</li>' : '', '</ul></td></tr>');
    }
    output.append((opt_data.notes) ? '<tr><td class="subSectionTitle">Note:</td><td class="subSectionText"><p class="preserve">' + soy.$$escapeHtml(opt_data.notes) + '</p></td></tr>' : '', (opt_data.showMu && opt_data.meaningfulUseInfo && opt_data.meaningfulUseInfo.transitionOfCare) ? '<tr><td class="subSectionTitle">MIPS:</td><td class="subSectionText">' + ((opt_data.meaningfulUseInfo.transitionOfCare || opt_data.meaningfulUseInfo.currentMedsDocumented) ? ((opt_data.meaningfulUseInfo.transitionOfCare) ? ((opt_data.meaningfulUseInfo.transitionOfCare == 'receiving') ? (opt_data.meaningfulUseInfo.isMedsReconciled) ? '<p class="preserve">Transition of care: performed medication reconciliation.</p>' : '<p class="preserve">Transitioned from another care setting.</p>' : '') + ((opt_data.meaningfulUseInfo.transitionOfCare == 'referring') ? '<p class="preserve">Referred to another care setting' + ((opt_data.meaningfulUseInfo.noteSummaryProvided && opt_data.meaningfulUseInfo.summaryOfCareProvided) ? ' with clinical summary and summary of care record.' : (opt_data.meaningfulUseInfo.noteSummaryProvided) ? ' with clinical summary.' : (opt_data.meaningfulUseInfo.summaryOfCareProvided) ? ' with summary of care record.' : '.') + '</p>' : '') + ((opt_data.meaningfulUseInfo.transitionOfCare == 'both') ? '<p class="preserve">Transitioned from another care setting and referred to another care setting.' + ((opt_data.meaningfulUseInfo.isMedsReconciled && opt_data.meaningfulUseInfo.noteSummaryProvided) ? ' Performed medication reconciliation and shared clinical summary' + ((opt_data.meaningfulUseInfo.summaryOfCareProvided) ? ' and summary of care record' : '') + '.' : (opt_data.meaningfulUseInfo.summaryOfCareProvided && opt_data.meaningfulUseInfo.noteSummaryProvided) ? ' Shared clinical summary and summary of care record.' : (opt_data.meaningfulUseInfo.isMedsReconciled) ? ' Performed medication reconciliation.' : (opt_data.meaningfulUseInfo.noteSummaryProvided) ? ' Shared clinical summary.' : (opt_data.meaningfulUseInfo.summaryOfCareProvided) ? ' Shared summary of care record.' : '.') + '</p>' : '') : '') + ((opt_data.meaningfulUseInfo.currentMedsDocumented) ? '<p class="preserve">Patient\'s current medications documented in chart.</p>' : '') : '') + '</td></tr>' : '', '</table>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.title = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="mt25 fr"><img src="', (opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '', '/static/images/logo_fax_300dpi.jpg', (! opt_data.localFsPath) ? '?v=20160729' : '', '" height="12" width="80"></p><h2 class="documentTitleSmall">');
  el8.template.ptdata.model.note.visitNoteDescription(opt_data.note, output);
  output.append('</h2>');
  el8.template.print.patientInfoNotes({patient: opt_data.patient, timeOfPhrase: 'visit', physicianName: opt_data.note.prescribingPhysicianName, displayPatientAge: opt_data.note.displayPatientAge}, output);
  output.append('<h3 class="mt10">Date of Encounter: ', (soy.$$escapeHtml(opt_data.note.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.note.documentDate)) : ''), '</h3>');
  if (!opt_sb) return output.toString();
};
